<template>
  <SdfFocusPane
    :name="confirmationPaneName"
    :heading="options.title"
    :closeable="!isLoading && !options.preventClose"
    :error-msg="confirmationPaneErrorMsg"
    @sdf-after-open="onBeforeOpen"
    @sdf-after-close="onClosed"
  >
    <Component :is="options.body" v-if="isComponent(options.body)" v-bind="options.bodyProps" />
    <p v-else class="whitespace-pre-line">
      {{ options.body }}
    </p>

    <!--
    Note: Using `|| undefined` pattern for boolean props because web component
    CSS selectors like :host([disabled]) match when attribute EXISTS, regardless of value.
    So disabled="false" still triggers the disabled styling.
    -->
    <template #custom-buttons>
      <div class="flex gap-4">
        <SdfButton
          emphasis="secondary"
          data-testid="confirmation-pane-cancel-button"
          :button-title="options.cancelButtonText"
          :disabled="isLoading || undefined"
          @click="onCancel"
        >
          {{ options.cancelButtonText }}
        </SdfButton>
        <SdfButton
          emphasis="primary"
          :action="confirmButtonActionType"
          :disabled="undefined"
          data-testid="confirmation-pane-confirm-button"
          :button-title="options.confirmButtonText"
          :busy="isLoading || undefined"
          @click="onConfirm"
        >
          {{ options.confirmButtonText }}
        </SdfButton>
      </div>
    </template>
  </SdfFocusPane>
</template>

<script setup lang="ts">
import { confirmationPaneName } from '@pequity/shared/components/confirmation-pane/constants';
import { useConfirmationPane } from '@pequity/shared/composables/useConfirmationPane';
import { SdfButton, SdfFocusPane } from '@pequity/shared/ui';
import { isComponent } from '@pequity/shared/utils/component';
import { computed } from 'vue';

defineOptions({
  name: 'ConfirmationPane',
});

// Data
const {
  confirmationPaneOptions: options,
  confirmationPaneErrorMsg,
  isLoading,
  onConfirm,
  onCancel,
  onBeforeOpen,
  onClosed,
} = useConfirmationPane();

// Computed
const confirmButtonActionType = computed(() => {
  if (options.value.type === 'danger') {
    return 'destructive';
  }

  return undefined;
});
</script>
